import React, { useEffect, useMemo, useState } from "react";
import {
  dateIsAfter,
  dateIsBetween,
  getPeruISOStringAtEnd,
  getPeruISOStringAtZero,
} from "../utils/timeFuncs";

const TableInput = ({
  updValue,
  props,
  rowPos,
  col,
  value,
  w,
  dateLimits,
  validateChange,
  extraProp,
  blocksChanges,
}) => {
  //const [editing, setEditing] = useState(false);
  const [localValue, setLocalValue] = useState(value);

  //======================================================
  const isInvalidDate = useMemo(() => {
    if (dateLimits && props?.type == "date")
      return !dateIsBetween(
        dateLimits.initDate,
        dateLimits.endDate,
        localValue
      );
  }, [localValue, dateLimits]);

  //======================================================
  const isValidDate = () => {
    return !isInvalidDate;
  };
  //======================================================
  const onChange = (e) => {
    // Evitar la entrada de "-" solo
    if (e.target.value === "-") {
      return;
    }

    if (blocksChanges) {
      blocksChanges[rowPos].hasChanged = true;
    }

    setLocalValue(e.target.value);
    let newValue = e.target.value;
    if (props.type == "number") {
      if (!/^\d*$/.test(newValue)) {
        return;
      }
      // Si el campo está vacío, ponerlo en 0
      if (newValue === "") {
        newValue = "0"; // Lo mantenemos como string "0"
      } else {
        // Si no está vacío, quitamos los ceros a la izquierda y convertimos a número
        newValue = newValue.replace(/^0+/, "");
        if (newValue === "") newValue = "0"; // Aseguramos que no quede vacío
      }
    } else if (props.type === "date") {
      col == "endDate"
        ? (newValue = getPeruISOStringAtEnd(newValue))
        : (newValue = getPeruISOStringAtZero(newValue));
    }

    if (!extraProp) {
      updValue(newValue, rowPos, col);
    } else {
      updValue(rowPos, extraProp, col, newValue);
    }

    if (props.type === "date") {
      validateChange(rowPos, isValidDate());
    }
  };

  // useEffect(() => {
  //   //detercar cambio de estado
  //   setEditing(false);
  // }, [updatingBlock]);

  useEffect(() => {
    if (props.type == "date") setLocalValue(new Date(value.split("T")[0]));
  }, []);

  return (
    <div
      className={` rounded-[2px] w-fit text-sm ${
        isInvalidDate ? "text-red-600" : ""
      }`}
    >
      <input
        lang="es"
        onChange={onChange}
        {...props}
        //readOnly={props.type === "date"}
        value={localValue || ""}
        className={`bg-white font-poppins text-sm rounded-[5px] p-[2px] border-[1px] border-accent-green  ${w}`}
      />
    </div>
  );
};

export default TableInput;
